import { isEmpty } from "lodash";
import { Box, Small, P, FlexItem } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import themeGet from "@styled-system/theme-get";

import { TreeHeader, TreeHeaderTitle } from "src/shared/TreeView/TreeView";
import { RichTextContentViewer } from "src/shared/RichTextContent/RichTextContent";

const TreeText = styled(P)`
  word-break: break-word;
  z-index: 2;
  transition: ${themeGet("transition.transitionDefault")};
  color: ${(props) =>
    props.isActive
      ? themeGet("colors.primary")(props)
      : themeGet("colors.greyDarkest")(props)};

  ${TreeHeader}:hover & {
    color: ${(props) => themeGet("colors.primary")(props)};
  }
`;

const TagTreeHeader = ({ node, onToggle, onActivate }) => {
  const { isTagType, isTagTypeDesc, name, tagValue, children, active } = node;

  if (isTagType) {
    const onClickTagType = (e) => {
      e.stopPropagation();
      if (!isEmpty(children)) {
        onToggle(node, !node.toggled);
      } else {
        onActivate(node);
      }
    };

    const hasChildren = Boolean(node.children);

    return (
      <TreeHeader onClick={onClickTagType} isActive={active}>
        <TreeHeaderTitle
          data-testid="treeheader-node-name"
          hasChildren={hasChildren}
          hasToggle={hasChildren}
        >
          <TreeText fontSize="1" isActive={active}>
            {name}
          </TreeText>
        </TreeHeaderTitle>
      </TreeHeader>
    );
  }

  if (isTagTypeDesc) {
    return (
      <Box ml="l" dataTestId="tag-type-desc-node">
        <RichTextContentViewer content={node.details} fontSize="1.2rem" />
      </Box>
    );
  }

  const { appliedCount } = tagValue || {};
  const hasChildren = Boolean(node.children);

  const onClickTag = (e) => {
    e.stopPropagation();
    onActivate(node);
  };

  return (
    <TreeHeader onClick={onClickTag} isActive={active}>
      <TreeHeaderTitle
        data-testid="treeheader-node-name"
        hasChildren={hasChildren}
        hasToggle={hasChildren}
      >
        <TreeText fontSize="1" isActive={active}>
          {name}
        </TreeText>
        <FlexItem flex="0 0 auto">
          <Small color="greyDark">
            {appliedCount ? `${appliedCount} tagged` : ""}
          </Small>
        </FlexItem>
      </TreeHeaderTitle>
    </TreeHeader>
  );
};

TagTreeHeader.propTypes = {
  node: PropTypes.object,
  onToggle: PropTypes.func,
  onActivate: PropTypes.func,
};

export default TagTreeHeader;
